import { createSelector } from 'reselect'

const getState = state => state.ranks

export const getRanks = createSelector(getState, ({ ranks }) => ranks)
